export default "__VITE_ASSET__1599db7c__"